/**
 * @generated SignedSource<<5022827b0cf09752cd5776daf30e953d>>
 * @relayHash 07605b0f94d6bfbf5c86ce6f43ee8794
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID be24ced784c52f79da3d55ac5f28cc6bfb935162a401321cfc383e982ab1480e

import type { ConcreteRequest } from 'relay-runtime';
export type HelpButtonQuery$variables = Record<PropertyKey, never>;
export type HelpButtonQuery$data = {
  readonly user: {
    readonly emails: ReadonlyArray<{
      readonly value: string | null;
    } | null> | null;
  } | null;
};
export type HelpButtonQuery = {
  response: HelpButtonQuery$data;
  variables: HelpButtonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "current",
    "value": true
  }
],
v1 = {
  "concreteType": "AtlassianUserEmail",
  "kind": "LinkedField",
  "name": "emails",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "HelpButtonQuery",
    "selections": [
      {
        "alias": "user",
        "args": (v0/*: any*/),
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HelpButtonQuery",
    "selections": [
      {
        "alias": "user",
        "args": (v0/*: any*/),
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
      }
    ]
  },
  "params": {
    "cacheID": "07605b0f94d6bfbf5c86ce6f43ee8794",
    "id": "be24ced784c52f79da3d55ac5f28cc6bfb935162a401321cfc383e982ab1480e",
    "metadata": {},
    "name": "HelpButtonQuery",
    "operationKind": "query",
    "text": "query HelpButtonQuery{user:confluence_atlassianUser(current:true){emails{value},id}}"
  }
};
})();

(node as any).hash = "ea68606a14f00f692f5d23a208b10f51";

export default node;
